export enum Location{
    CART = 'cart',
    LANDING_PAGE = 'landing_page',
    ERROR = 'error',
    COMMON = 'common'
}

export enum LocationActions{
    SET_LOCATION = 'SET_LOCATION'
}